import React from 'react';
import './AboutImage.css'
import exampleImage from '../../images/aboutus.jpg'; // Import your image here

const AboutImage = () => {
  return (
    <div className='single-image-container'>
    <div className="single-image-section">
      <img src={exampleImage} alt="Example Image" className='responsive-image' />
    </div>
    </div>
  );
};

export default AboutImage;
